import {Injectable} from '@angular/core';
import {ApiService} from '../services/api.service';
import {Observable} from 'rxjs/index';
import {LoadingService} from '../services/loading.service';
import {NotificationsService} from '../services/notifications.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {NotificationType} from '../models/notification';
import {StorageService} from '../services/storage.service';
import {AuthenticationService} from '../services/authentication.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

interface SigninResponse {
  ip: string;
}

@Injectable()
export class SignService {
  public serviceId: string;
  private userIp: string;

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private http: HttpClient,
    private loadingService: LoadingService,
    private notificationService: NotificationsService,
    private translateService: TranslateService,
    private storageService: StorageService,
    private router: Router
  ) {
    this.userIp = '';
    this.getUserIp();
  }

  private displayMessage(notificationType, errorCode: string) {
    let message: string;
    this.translateService.get(errorCode).subscribe((res: string) => {
      message = res;
    });
    this.loadingService.hide();
    if (NotificationType.Error === notificationType) {
      return this.notificationService.error(message);
    }
    if (NotificationType.Success === notificationType) {
      return this.notificationService.success(message);
    }
  }

  public signin(data) {
    const postBody = Object.assign({}, data, {
      // 'fk_dict_application_id': environment.admin_gdpr.id,
      'fan_application_sub': environment.services_panel.code,
      'fk_dict_device_type_id': 1,
      'user_ip_address': this.userIp
    });

    const options = {
      body: postBody
    };
    this.apiService.post('/login', options, true).subscribe(
      (response) => {
        // if (response.status !== '201') {
        //   return this.displayMessage(NotificationType.Error, 'sign.actions.signin.invalid_credentials');
        // }
        this.storageService.setItem('refreshToken', response.refresh_token);
        this.storageService.setItem('token', response.token);
        this.storageService.setItem('isLogged', true);
        this.authService.isAuthenticated$.next(true);
        this.router.navigateByUrl('/services');
        this.displayMessage(NotificationType.Success, 'sign.actions.signin.success');
      }, (error) => {
        this.displayMessage(NotificationType.Error, 'general.api.error');
      }
    );
  }

  public signout() {
    const options = {};
    this.apiService.post('/logout', options, true).subscribe(
      (response) => {
        this.storageService.clear();
        this.authService.isAuthenticated$.next(false);
        this.router.navigateByUrl('/signin');
        this.displayMessage(NotificationType.Success, 'sign.actions.signout.success');
      }, (error) => {
        this.displayMessage(NotificationType.Error, 'sign.actions.signout.error');
      });
  }

  public forgotPassword(data): Observable<any> {
    const options = {
      body: data
    };
    return this.apiService.post('/profile/forgot-password', options, true);
  }

  public confirmForgotPassword(data): Observable<any> {
    const options = {
      body: data
    };
    return this.apiService.post('/profile/confirm-forgot-password', options, true);
  }

  public applicationInfo(data): Observable<any> {
    const options = {
      body: data
    };
    return this.apiService.post('application/get', options);
  }

  public getUserIp() {
    return this.http.get('https://json.geoiplookup.io/api').subscribe((response: SigninResponse) => {
      if (response && response.ip) {
        this.userIp = response.ip;
      }
    });
  }

}
